import { PmiButton } from 'shell/components/shared/button';
import { Fragment, memo, ReactElement } from 'react';
import AccordionDocument from '../../shared/document';

interface StepAttachmentsProps {
  praticaKey?: {
    cdEnte: string;
    tipoPratica: string;
    idAnnoPratica: number;
    pgPratica: number;
  } | null;
  onAvanza?: () => void;
  onIndietro?: () => void;
}

const StepAttachmentsComponent = ({ onAvanza, onIndietro }: StepAttachmentsProps): ReactElement => {
  return (
    <Fragment>
      <AccordionDocument isAire />

      <div className="pmi-pt-3 pmi-d-flex pmi-justify-content-center">
        <div className="pmi-w-25 pmi-w-lg-15">
          <PmiButton
            variant="outlined"
            fullWidth
            color="cdmBrand"
            onClick={() => {
              if (onIndietro) {
                onIndietro();
              }
            }}
          >
            Indietro
          </PmiButton>
        </div>
        <div className="pmi-pl-2 pmi-w-25 pmi-w-lg-15">
          <PmiButton
            variant="outlined"
            fullWidth
            color="cdmBrandThird"
            onClick={() => {
              if (onAvanza) {
                onAvanza();
              }
            }}
          >
            Conferma
          </PmiButton>
        </div>
      </div>
    </Fragment>
  );
};

StepAttachmentsComponent.displayName = 'Step Attachments component';

const StepAttachments = memo(StepAttachmentsComponent);

export default StepAttachments;
